export default function getCookieMap(cookie: string) {
  return cookie
    .split(';')
    .map(c => c.trim())
    .map(c => c.split('='))
    .reduce((map, [key, value]) => ({
      ...map,
      [key]: value
    }), {});
}